const { __ } = wp.i18n;

export const getConditionTypes = ({ isPreset = false, includeExcluded = false }) => {
  const proLabel = !conditionalblocks?.is_pro ? ` - ${__('Pro', 'conditional-blocks')}` : '';

  const ready = conditionalblocks?.is_pro && conditionalblocks?.is_active && conditionalblocks?.plugins_page_url;

  const excludedConditionTypes = conditionalblocks?.excluded_condition_types ?? [];
  const excludedCategories = conditionalblocks?.excluded_categories ?? [];

  let categoriesWithConditions = [
    {
      label: __('General', 'conditional-blocks'),
      value: 'general',
      icon: 'admin-customizer',
      options: [
        { value: 'lockdown', label: __('Lockdown (Hide block from everyone)', 'conditional-blocks') },
        {
          value: 'responsiveScreenSizes',
          label: __('Responsive (Screens sizes)', 'conditional-blocks'),
          isDisabled: isPreset,
        },
      ],
    },
    {
      label: __('User', 'conditional-blocks'),
      value: 'user',
      icon: 'admin-users',
      options: [
        { value: 'userLoggedIn', label: __('User Logged In', 'conditional-blocks') },
        { value: 'userLoggedOut', label: __('User Logged Out', 'conditional-blocks') },
        { value: 'userRoles', label: __('User Roles', 'conditional-blocks') + proLabel, isDisabled: !ready },
        { value: 'userMeta', label: __('User Meta Field', 'conditional-blocks') + proLabel, isDisabled: !ready },
      ],
    },
    {
      label: __('Posts & CPT', 'conditional-blocks'),
      value: 'posts',
      icon: 'admin-post',
      options: [
        { value: 'postType', label: __('Post Types', 'conditional-blocks') + proLabel, isDisabled: !ready },
        {
          value: 'postTaxonomyTerms',
          label: __('Post Taxonomy & Terms', 'conditional-blocks') + proLabel,
          isDisabled: !ready,
        },
        { value: 'posts', label: __('Posts (Includes CPT)', 'conditional-blocks') + proLabel, isDisabled: !ready },
        {
          value: 'postMeta',
          label: __('Post Meta (Custom Fields)', 'conditional-blocks') + proLabel,
          isDisabled: !ready,
        },
        { value: 'postIds', label: __('Post IDs', 'conditional-blocks') + proLabel, isDisabled: !ready },
        { value: 'archive', label: __('Archive', 'conditional-blocks') + proLabel, isDisabled: !ready },
      ],
    },
    {
      label: __('Server Request', 'conditional-blocks'),
      value: 'server',
      icon: 'database',
      options: [
        {
          value: 'queryStrings',
          label: __('Query Strings (URL Variables)', 'conditional-blocks') + proLabel,
          isDisabled: !ready,
        },
        {
          value: 'domainReferrers',
          label: __('Domain Referrers', 'conditional-blocks') + proLabel,
          isDisabled: !ready,
        },
        { value: 'urlPaths', label: __('URL Paths', 'conditional-blocks') + proLabel, isDisabled: !ready },
        {
          value: 'userAgents',
          label: __('User Agents (Devices & Browsers)', 'conditional-blocks') + proLabel,
          isDisabled: !ready,
        },
        { value: 'cookies', label: __('Cookies', 'conditional-blocks') + proLabel, isDisabled: !ready },
      ],
    },
    {
      label: __('Time', 'conditional-blocks'),
      value: 'time',
      icon: 'calendar',
      options: [
        { value: 'dateRange', label: __('Date Schedule - Range', 'conditional-blocks') + proLabel, isDisabled: !ready },
        {
          value: 'dateRecurring',
          label: __('Date Schedule - Recurring', 'conditional-blocks') + proLabel,
          isDisabled: !ready,
        },
      ],
    },
    {
      label: __('Geolocation', 'conditional-blocks'),
      value: 'geolocation',
      icon: 'admin-site-alt2',
      options: [
        {
          value: 'geolocationCountry',
          label: __('Geolocation - Country', 'conditional-blocks') + proLabel,
          isDisabled: !ready,
        },
        {
          value: 'geolocationContinent',
          label: __('Geolocation - Continent', 'conditional-blocks') + proLabel,
          isDisabled: !ready,
        },
      ],
    },
    {
      label: __('Advanced', 'conditional-blocks'),
      value: 'advanced',
      icon: 'rest-api',
      options: [{ value: 'phpLogic', label: __('PHP Logic', 'conditional-blocks') + proLabel, isDisabled: !ready }],
    },
  ];

  if (
    (conditionalblocks?.only_installed_integrations && conditionalblocks?.is_wc_active) ||
    !conditionalblocks?.only_installed_integrations
  ) {
    categoriesWithConditions.push({
      label: __('WooCommerce', 'conditional-blocks'),
      value: 'woocommerce',
      icon: conditionalblocks?.plugin_url
        ? `${conditionalblocks.plugin_url}/assets/images/mini-colored/woocommerce.svg`
        : false,
      options: [
        {
          value: 'wcCartTotal',
          label: __('Cart Value', 'conditional-blocks') + proLabel,
          isDisabled: !ready || !conditionalblocks.is_wc_active,
        },
        {
          value: 'wcCartProducts',
          label: __('Cart Products', 'conditional-blocks') + proLabel,
          isDisabled: !ready || !conditionalblocks.is_wc_active,
        },
        {
          value: 'wcCartProductCategories',
          label: __('Cart Product Categories', 'conditional-blocks') + proLabel,
          isDisabled: !ready || !conditionalblocks.is_wc_active,
        },
        {
          value: 'wcCustomerTotalSpent',
          label: __('Customer Total Spent', 'conditional-blocks') + proLabel,
          isDisabled: !ready || !conditionalblocks.is_wc_active,
        },
        {
          value: 'wcCustomerRecentOrder',
          label: __('Customer Recent Order', 'conditional-blocks') + proLabel,
          isDisabled: !ready || !conditionalblocks.is_wc_active,
        },
        {
          value: 'wcGeoLocation',
          label: __('Geolocation', 'conditional-blocks') + proLabel,
          isDisabled: !ready || !conditionalblocks.is_wc_active,
        },
      ],
    });
  }

  //  Register new condition groups and use their labels.
  if (conditionalblocks.registered_categories && conditionalblocks.registered_conditions_types) {
    const conditionsByCategory = {};

    for (const condition of conditionalblocks.registered_conditions_types) {
      if (!conditionsByCategory[condition.category]) {
        conditionsByCategory[condition.category] = [];
      }

      if (condition?.tag === 'plugin' && condition?.is_disabled && conditionalblocks?.only_installed_integrations) {
        continue;
      }

      // Insert the new condition.
      conditionsByCategory[condition.category].push({
        label: condition.label + (condition?.is_pro ? proLabel : ''),
        value: condition.type,
        configuration: condition,
        isDisabled: condition?.is_disabled || (condition?.is_pro && !ready),
      });
    }

    // Insert the new condition category.
    for (const category of conditionalblocks.registered_categories) {
      const categoryConfig = {
        value: category.value,
        label: category.label,
        icon: category?.icon ?? false,
        options: conditionsByCategory[category.value] ?? null,
      };

      categoriesWithConditions.push(categoryConfig);
    }
  }

  // If this isn't used for presets then we allow presets to be selected.
  if (!isPreset) {
    categoriesWithConditions.push({
      label: __('Preset Manager', 'conditional-blocks'),
      icon: 'admin-site',
      options: [{ value: 'presets', label: __('Presets', 'conditional-blocks') + proLabel, isDisabled: !ready }],
    });
  }

  /**
   * Exclude condition types and categories from rendering in the UI.
   */
  // Filter out excluded condition types
  if (excludedConditionTypes.length && !includeExcluded) {
    categoriesWithConditions = categoriesWithConditions.map((category) => ({
      ...category,
      options: category.options.filter((option) => !excludedConditionTypes.includes(option.value)),
    }));
  }
  // Filter out excluded categories.
  if (excludedCategories.length && !includeExcluded) {
    categoriesWithConditions = categoriesWithConditions.filter((cat) => !excludedCategories.includes(cat.value));
  }

  return categoriesWithConditions;
};

export const getSingleConditionType = (findType) => {
  if (!findType) {
    return false;
  }
  let foundTypeObj = false;

  getConditionTypes({ includeExcluded: true }).find((section) =>
    section.options.find((obj) => {
      if (obj.value === findType) {
        foundTypeObj = obj;
        return true;
      }
      return false;
    }),
  );

  return foundTypeObj;
};

export const findCategoryFromConditionType = (conditionId) => {
  if (!conditionId) {
    return false;
  }
  let foundSectionObj = false;

  getConditionTypes({ includeExcluded: true }).find((section) =>
    section.options.find((obj) => {
      if (obj.value === conditionId) {
        foundSectionObj = section;
        return true;
      }
      return false;
    }),
  );

  return foundSectionObj;
};
